<nb-card>
<div class="att-container">
  <div style="display: flex; flex-direction: column; gap: 10px;">
  <div class="calendar-wrapper" >
    <p style="color: #2a7fe1; font-weight: bold;">{{dayAndTime()}}</p>
    <nb-calendar
      [dayCellComponent]="dayCellComponent"
      [min]="minDate"
      [max]="maxDate"
      [showNavigation]="true"
      (dateChange)="onDateChange($event)"
      *ngIf="type === 'regularization'">
    </nb-calendar>
    

   
    <nb-calendar-range [dayCellComponent]="leaveCellComponent" [(range)]="range"
      (rangeChange)="handleRangeChange($event)" *ngIf="type === 'leave'">
    </nb-calendar-range>

  </div>
  <div>
  
    <div class="option-toggle" *ngIf="type === 'regularization'">
  <button

    [class.active]="option === 'leave'"
    (click)="onOptionChange('leave')"
    class="right"
  >
  <nb-icon *ngIf="option === 'leave'" icon="checkmark-outline"></nb-icon>
    Apply Leave
    
  </button>

  <button
    class="left"
    [class.active]="option === 'attendance'"
    (click)="onOptionChange('attendance')"
  >
  <nb-icon *ngIf="option === 'attendance'" icon="checkmark-outline"></nb-icon>
    Regularize Miss Punches
    
  </button>
</div>

    
  </div>
  </div>
  <div class="option-wrapper" *ngIf="option === 'leave' || type === 'leave'">
    <p style="padding: 0px; margin: 0px; font-weight: bold;">Details</p>
    <div class="form-field">
      <label class="field-label">Type</label>

      <nb-select placeholder="Select Leave Type" class="leave-select" [(ngModel)]="selectedLeaveType"
        (ngModelChange)="onValChange()" style="width:180px;">
        <nb-option *ngFor="let leave of dropdown" [value]="leave">{{ leave.name }}</nb-option>
      </nb-select>
    </div>

    <!-- <div class="form-field">
      <label class="avail-leave-label field-label">Available leave</label>
      <input type="text" nbInput disabled value="18" class="available-leave">
    </div> -->

    <div class="date-container">
      <div class="form-field date-field">
        <label class="field-label">From</label>
        <nb-icon pack="eva" icon="calendar-outline" style="color: black;position: absolute; top: 10px; right: 4px;"></nb-icon>
        <input
          class="date-input"
          nbInput
          placeholder="select date"
          [nbDatepicker]="startPicker"
          [disabled]="isRegularizationLeaveMode"
          [(ngModel)]="range.start"
          [value]="leaveStartInputValue"
          (ngModelChange)="onLeaveStartDateChange($event)" />
        <nb-datepicker #startPicker format="dd-MMM-yy"></nb-datepicker>
      </div>
      <div class="form-field date-field">
        <nb-icon pack="eva" icon="calendar-outline" style="color: black;position: absolute; top: 10px; right: 4px;"></nb-icon>
        <label class="field-label">To</label>
        <input
          class="date-input"
          nbInput
          placeholder="select date"
          [nbDatepicker]="endPicker"
          [disabled]="isRegularizationLeaveMode"
          [(ngModel)]="range.end"
          [value]="leaveEndInputValue"
          (ngModelChange)="onLeaveEndDateChange($event)" />
        <nb-datepicker #endPicker format="dd-MMM-yy"></nb-datepicker>
      </div>
    </div>
        <div class="form-field">
      <label class="avail-leave-label field-label">Total days</label>
      <input type="text" nbInput disabled [value]="leaveTotalDays" class="available-leave">
    </div>


    
    <div class="file-input-wrapper" *ngIf="selectedLeaveType?.attachment_required">
      <input nbInput type="file" (change)="onFileChange($event)" [class.required-file]="isFileUploadRequired()"
        [class.missing-file]="isFileUploadRequired() && !selectedFile" placeholder="Select file">
    </div>
    
    <div class="text-area" style="height: 40%;">
      <textarea nbInput fullWidth [(ngModel)]="leaveReason" (ngModelChange)="emitPrompt()"
        placeholder="Please give reason (optional)"></textarea>
    </div>
    
  </div>
  
  

</div>

</nb-card>
